import { DATATYPES } from 'ontraccr-common/lib/Definitions';

export const ATTRIBUTE_LINK_MAP = {
  Customer: 'Customers',
  Project: 'Projects',
  'Project Contract': 'Projects',
  Vendor: 'Vendors',
  Contact: 'Contacts',
  Costcodes: 'Costcodes',
  User: 'Users',
  'Sub-Contract': 'Sub-Contracts',
  Buckets: 'Buckets',
  PayableSubContracts: 'PayableSubContracts',
};

export const DYNAMIC_ATTRIBUTE_LINK_MAP = {
  projects: 'Projects',
  equipment: 'Equipment',
  customers: 'Customers',
  users: 'Users',
};

export const getAttributeOptions = (t) => [
  {
    name: `${t('Customer')}`,
    value: DATATYPES.Customer,
  },
  {
    name: 'Contact',
    value: DATATYPES.Contact,
  },
  {
    name: `${t('Project')}`,
    value: DATATYPES.Project,
  },
  {
    name: `${t('Project')} Contract`,
    value: DATATYPES.ProjectContract,
  },
  {
    name: 'Vendor',
    value: DATATYPES.Vendor,
  },
  {
    name: 'Costcodes',
    value: DATATYPES.Costcodes,
  },
  {
    name: 'User',
    value: DATATYPES.User,
  },
  {
    name: 'SoV Sub-Contract',
    value: DATATYPES.SubContract,
  },
  {
    name: 'Buckets',
    value: DATATYPES.Buckets,
    hasSubDataType: true,
  },
  {
    name: 'Sub-Contract',
    value: DATATYPES.PayableSubContracts,
  },
];

export const getLinkOptions = ({
  dataType,
  sections,
  subDataType,
  hasSubDataType,
}) => (
  dataType
    ? (
      sections.reduce((acc, section) => {
        const { fields = [], name: sectionName } = section;
        return acc.concat(
          fields.reduce((fieldAcc, field) => {
            const {
              id: fieldId,
              selectedType,
              configProps: {
                dataType: fieldDataType,
                title: fieldTitle,
                subDataType: fieldSubDataType,
              } = {},
            } = field;
            if (selectedType !== 'dropdown') return fieldAcc;
            if (
              fieldDataType !== ATTRIBUTE_LINK_MAP[dataType]
              || (hasSubDataType && fieldSubDataType !== subDataType)
            ) return fieldAcc;
            return fieldAcc.concat([{
              label: `${sectionName} - ${fieldTitle}`,
              value: fieldId,
            }]);
          }, []),
        );
      }, [])
    )
    : []
);

/**
 * Gets dropdown field options for dynamic attribute linking
 * @param {string} dataType - Dynamic attribute dataType ('projects', 'equipment', 'customers', 'users')
 * @param {Array} sections - Form sections
 * @returns {Array} Options for the link field select
 */
export const getDynamicAttributeLinkOptions = ({
  dataType,
  sections = [],
}) => {
  const dropdownDataType = DYNAMIC_ATTRIBUTE_LINK_MAP[dataType];
  if (!dropdownDataType) return [];

  return sections?.reduce((acc, section) => {
    const { fields = [], name: sectionName } = section ?? {};
    return acc.concat(
      fields?.reduce((fieldAcc, field) => {
        const {
          id: fieldId,
          selectedType,
          configProps: {
            dataType: fieldDataType,
            title: fieldTitle,
          } = {},
        } = field ?? {};
        if (selectedType !== 'dropdown') return fieldAcc;
        if (fieldDataType !== dropdownDataType) return fieldAcc;
        return fieldAcc.concat([{
          label: `${sectionName} - ${fieldTitle}`,
          value: fieldId,
        }]);
      }, []),
    );
  }, []);
};
